/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Card_LocationInputs */

const en_job_card_location = /** @type {(inputs: Job_Card_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const de_job_card_location = /** @type {(inputs: Job_Card_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Job_Card_LocationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_card_location = /** @type {((inputs?: Job_Card_LocationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Card_LocationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_card_location(inputs)
	return en_job_card_location(inputs)
});